import { Injectable, ɵɵdefineInjectable, ɵɵinject, InjectionToken, Inject, Component, NgModule, Directive, Input, HostListener, HostBinding, NgZone, APP_INITIALIZER } from '@angular/core';
import { HttpClient, HttpClientModule, HttpXsrfTokenExtractor } from '@angular/common/http';
import { fromEvent, ReplaySubject } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { Location } from '@angular/common';
import { NavigationEnd, NavigationError, NavigationCancel, Router, ActivatedRoute } from '@angular/router';
import { ResizeObserver } from '@juggle/resize-observer';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/fnw-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/router';
class FnwConfig {
}
if (false) {
    /** @type {?} */
    FnwConfig.prototype.serviceName;
    /** @type {?} */
    FnwConfig.prototype.isMonolith;
    /** @type {?} */
    FnwConfig.prototype.debug;
    /** @type {?} */
    FnwConfig.prototype.getTranslation;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/navigation/message.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FnwMessageService {
    /**
     * @param {?} config
     */
    constructor(config) {
        this.config = config;
    }
    /**
     * @return {?}
     */
    onMessage() {
        return fromEvent(window, 'message').pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        (event) => event.origin === location.origin)), map((/**
         * @param {?} event
         * @return {?}
         */
        (event) => event.data)), filter((/**
         * @param {?} data
         * @return {?}
         */
        (data) => data.type && data.type.startsWith('fnw-'))), tap((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            if (this.config.debug) {
                console.log('[Companion receive]', data);
            }
        })));
    }
    /**
     * @param {?} message
     * @return {?}
     */
    postMessage(message) {
        if (this.config.debug) {
            console.log('[Companion send]', message);
        }
        parent.postMessage(message, location.origin);
    }
}
FnwMessageService.ɵfac = function FnwMessageService_Factory(t) { return new (t || FnwMessageService)(ɵngcc0.ɵɵinject(FnwConfig)); };
FnwMessageService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FnwMessageService, factory: FnwMessageService.ɵfac, providedIn: 'root' });
/** @nocollapse */
FnwMessageService.ctorParameters = () => [
    { type: FnwConfig }
];
/** @nocollapse */ FnwMessageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FnwMessageService_Factory() { return new FnwMessageService(ɵɵinject(FnwConfig)); }, token: FnwMessageService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwMessageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: FnwConfig }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    FnwMessageService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/credentials/location.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const LOCATION = new InjectionToken('browser-location', {
    providedIn: 'root',
    factory: (/**
     * @return {?}
     */
    () => location),
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/credentials/location.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FnwLocationService {
    /**
     * @param {?} path
     * @param {?=} params
     * @return {?}
     */
    static createUrl(path, params = {}) {
        /** @type {?} */
        let paramString = Object.entries(params)
            .map((/**
         * @param {?} keyValue
         * @return {?}
         */
        keyValue => keyValue.map(encodeURIComponent).join('=')))
            .join('&');
        paramString = Location.normalizeQueryParams(paramString);
        return path + paramString;
    }
}
FnwLocationService.ɵfac = function FnwLocationService_Factory(t) { return new (t || FnwLocationService)(); };
FnwLocationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FnwLocationService, factory: FnwLocationService.ɵfac, providedIn: 'root' });
/** @nocollapse */ FnwLocationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FnwLocationService_Factory() { return new FnwLocationService(); }, token: FnwLocationService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwLocationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/credentials/credentials.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const CREDENTIALS_ENDPOINT = '/365FarmNet/rest/credentials';
class FnwCredentialsService {
    /**
     * @param {?} http
     * @param {?} location
     * @param {?} messageService
     * @param {?} config
     */
    constructor(http, location, messageService, config) {
        this.http = http;
        this.messageService = messageService;
        this.config = config;
        // update subscribers before init and new subscribers with last value
        this.credentialsSubject = new ReplaySubject(1);
        this.location = (/** @type {?} */ (location));
        messageService.onMessage().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            switch (data.type) {
                case 'fnw-credentials-update': {
                    this.updateCredentials(data.credentials);
                    break;
                }
            }
        }));
    }
    /**
     * @return {?}
     */
    get credentials() {
        return this.credentialsSubject.asObservable();
    }
    /**
     * @private
     * @param {?} credentials
     * @return {?}
     */
    updateCredentials(credentials) {
        this.credentialsSubject.next(credentials);
    }
    /**
     * @private
     * @param {?} source
     * @return {?}
     */
    load(source) {
        return this.http.get(`${CREDENTIALS_ENDPOINT}?source=${source}`);
    }
    /**
     * @return {?}
     */
    postCredentialsChanged() {
        /** @type {?} */
        const message = {
            type: 'fnw-credentials-change',
            serviceName: this.config.serviceName,
        };
        this.messageService.postMessage(message);
    }
    /**
     * @return {?}
     */
    init() {
        return this.load('bootstrap').pipe(tap((/**
         * @param {?} credentials
         * @return {?}
         */
        credentials => {
            if (!credentials.loggedIn && !this.config.isMonolith) {
                /** @type {?} */
                const url = FnwLocationService.createUrl('/signon/login', {
                    requestedRoute: this.location.pathname + this.location.search,
                });
                this.location.assign(url);
                throw new Error('not logged in');
            }
            this.updateCredentials(credentials);
        })));
    }
    /**
     * @return {?}
     */
    keepAlive() {
        return this.load('keepAlive').pipe(tap((/**
         * @param {?} credentials
         * @return {?}
         */
        credentials => this.updateCredentials(credentials))));
    }
}
FnwCredentialsService.ɵfac = function FnwCredentialsService_Factory(t) { return new (t || FnwCredentialsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(LOCATION), ɵngcc0.ɵɵinject(FnwMessageService), ɵngcc0.ɵɵinject(FnwConfig)); };
FnwCredentialsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FnwCredentialsService, factory: FnwCredentialsService.ɵfac, providedIn: 'root' });
/** @nocollapse */
FnwCredentialsService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [LOCATION,] }] },
    { type: FnwMessageService },
    { type: FnwConfig }
];
/** @nocollapse */ FnwCredentialsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FnwCredentialsService_Factory() { return new FnwCredentialsService(ɵɵinject(HttpClient), ɵɵinject(LOCATION), ɵɵinject(FnwMessageService), ɵɵinject(FnwConfig)); }, token: FnwCredentialsService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwCredentialsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [LOCATION]
            }] }, { type: FnwMessageService }, { type: FnwConfig }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    FnwCredentialsService.prototype.credentialsSubject;
    /**
     * @type {?}
     * @private
     */
    FnwCredentialsService.prototype.location;
    /**
     * @type {?}
     * @private
     */
    FnwCredentialsService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    FnwCredentialsService.prototype.messageService;
    /**
     * @type {?}
     * @private
     */
    FnwCredentialsService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/credentials/credentials.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Credentials() { }
if (false) {
    /** @type {?} */
    Credentials.prototype.principalId;
    /** @type {?} */
    Credentials.prototype.userId;
    /** @type {?} */
    Credentials.prototype.usernameToDisplay;
    /** @type {?} */
    Credentials.prototype.loggedIn;
    /** @type {?} */
    Credentials.prototype.isLocked;
    /** @type {?} */
    Credentials.prototype.release;
    /** @type {?} */
    Credentials.prototype.cfn365site;
    /** @type {?} */
    Credentials.prototype.geoserverURL;
    /** @type {?} */
    Credentials.prototype.loginRedirectUrl;
    /** @type {?} */
    Credentials.prototype.locale;
    /** @type {?} */
    Credentials.prototype.company;
    /** @type {?} */
    Credentials.prototype.person;
    /** @type {?} */
    Credentials.prototype.stats;
    /** @type {?} */
    Credentials.prototype.rights;
    /** @type {?} */
    Credentials.prototype.licensedProducts;
    /** @type {?} */
    Credentials.prototype.licensedProductsDetails;
    /** @type {?} */
    Credentials.prototype.billedPricingCriteria;
    /** @type {?} */
    Credentials.prototype.availableProducts;
    /** @type {?} */
    Credentials.prototype.hiddenProducts;
    /** @type {?} */
    Credentials.prototype.sessionTimeoutSeconds;
    /** @type {?} */
    Credentials.prototype.userProperties;
    /** @type {?} */
    Credentials.prototype.userSettings;
    /** @type {?} */
    Credentials.prototype.customGroups;
}
/**
 * @record
 */
function LicensedProductsDetails() { }
if (false) {
    /** @type {?} */
    LicensedProductsDetails.prototype.key;
    /** @type {?} */
    LicensedProductsDetails.prototype.state;
    /** @type {?} */
    LicensedProductsDetails.prototype.hasPromoCode;
}
/** @enum {string} */
const SubscriptionState = {
    TRIAL: "TRIAL",
    TRIAL_CANCELLED: "TRIAL_CANCELLED",
    PAID: "PAID",
    PAID_CANCELLED: "PAID_CANCELLED",
    INACTIVE: "INACTIVE",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/credentials/load-credentials.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} credentialsService
 * @return {?}
 */
function loadCredentials(credentialsService) {
    /** @type {?} */
    const init = (/**
     * @return {?}
     */
    () => credentialsService.init().toPromise());
    return init;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/credentials/map-to-locale.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} farmnetLocale
 * @param {?} availableLangIds
 * @return {?}
 */
function mapToLocale(farmnetLocale, availableLangIds) {
    if (!availableLangIds.includes(farmnetLocale)) {
        const [userLocale, companyLocale] = farmnetLocale.split('-');
        /** @type {?} */
        const foundLocale = availableLangIds.find((/**
         * @param {?} availableLang
         * @return {?}
         */
        availableLang => availableLang.startsWith(userLocale)));
        if (foundLocale) {
            farmnetLocale = foundLocale;
        }
    }
    return farmnetLocale;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/credentials/right.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/credentials/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/fnw-messages.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FnwLocationUpdate() { }
if (false) {
    /** @type {?} */
    FnwLocationUpdate.prototype.type;
    /** @type {?} */
    FnwLocationUpdate.prototype.url;
    /** @type {?} */
    FnwLocationUpdate.prototype.serviceName;
    /** @type {?} */
    FnwLocationUpdate.prototype.section;
}
/**
 * @record
 */
function FnwNavigateToService() { }
if (false) {
    /** @type {?} */
    FnwNavigateToService.prototype.type;
    /** @type {?} */
    FnwNavigateToService.prototype.url;
    /** @type {?} */
    FnwNavigateToService.prototype.serviceName;
}
/**
 * @record
 */
function FnwTestNavigateToService() { }
if (false) {
    /** @type {?} */
    FnwTestNavigateToService.prototype.type;
    /** @type {?} */
    FnwTestNavigateToService.prototype.url;
}
/**
 * @record
 */
function FnwTestNavigateInService() { }
if (false) {
    /** @type {?} */
    FnwTestNavigateInService.prototype.type;
    /** @type {?} */
    FnwTestNavigateInService.prototype.url;
}
/**
 * @record
 */
function FnwAllowNavigation() { }
if (false) {
    /** @type {?} */
    FnwAllowNavigation.prototype.type;
    /** @type {?} */
    FnwAllowNavigation.prototype.serviceName;
    /** @type {?} */
    FnwAllowNavigation.prototype.url;
}
/**
 * @record
 */
function FnwRejectNavigation() { }
if (false) {
    /** @type {?} */
    FnwRejectNavigation.prototype.type;
    /** @type {?} */
    FnwRejectNavigation.prototype.serviceName;
    /** @type {?} */
    FnwRejectNavigation.prototype.url;
}
/**
 * @record
 */
function FnwSectionChange() { }
if (false) {
    /** @type {?} */
    FnwSectionChange.prototype.type;
    /** @type {?} */
    FnwSectionChange.prototype.section;
    /** @type {?} */
    FnwSectionChange.prototype.serviceName;
}
/**
 * @record
 */
function FnwScrollChange() { }
if (false) {
    /** @type {?} */
    FnwScrollChange.prototype.type;
    /** @type {?} */
    FnwScrollChange.prototype.scrollY;
    /** @type {?} */
    FnwScrollChange.prototype.scrollMaxY;
    /** @type {?} */
    FnwScrollChange.prototype.serviceName;
}
/**
 * @record
 */
function FnwHeightChange() { }
if (false) {
    /** @type {?} */
    FnwHeightChange.prototype.type;
    /** @type {?} */
    FnwHeightChange.prototype.scrollY;
    /** @type {?} */
    FnwHeightChange.prototype.scrollMaxY;
    /** @type {?} */
    FnwHeightChange.prototype.serviceName;
}
/**
 * @record
 */
function FnwCredentialsChange() { }
if (false) {
    /** @type {?} */
    FnwCredentialsChange.prototype.type;
    /** @type {?} */
    FnwCredentialsChange.prototype.serviceName;
}
/**
 * @record
 */
function FnwCredentialsUpdate() { }
if (false) {
    /** @type {?} */
    FnwCredentialsUpdate.prototype.type;
    /** @type {?} */
    FnwCredentialsUpdate.prototype.credentials;
}
/**
 * @record
 */
function FnwTrackProductEvent() { }
if (false) {
    /** @type {?} */
    FnwTrackProductEvent.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/fnw-navigation-route.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FNW_NAVIGATION_ROUTE = 'webapp-loader-companion';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/empty/empty.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FnwEmptyComponent {
    constructor() { }
}
FnwEmptyComponent.ɵfac = function FnwEmptyComponent_Factory(t) { return new (t || FnwEmptyComponent)(); };
FnwEmptyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FnwEmptyComponent, selectors: [["ng-component"]], decls: 0, vars: 0, template: function FnwEmptyComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
FnwEmptyComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwEmptyComponent, [{
        type: Component,
        args: [{
                template: ''
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/empty/empty.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FnwEmptyModule {
}
FnwEmptyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FnwEmptyModule });
FnwEmptyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FnwEmptyModule_Factory(t) { return new (t || FnwEmptyModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FnwEmptyModule, { declarations: [FnwEmptyComponent], exports: [FnwEmptyComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwEmptyModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [FnwEmptyComponent],
                exports: [FnwEmptyComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/empty/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/product-tracking/product-tracking.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FnwProductTrackingService {
    /**
     * @param {?} messageService
     */
    constructor(messageService) {
        this.messageService = messageService;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    trackEvent(event) {
        this.messageService.postMessage(Object.assign({ type: 'fnw-track-product-event' }, event));
    }
}
FnwProductTrackingService.ɵfac = function FnwProductTrackingService_Factory(t) { return new (t || FnwProductTrackingService)(ɵngcc0.ɵɵinject(FnwMessageService)); };
FnwProductTrackingService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FnwProductTrackingService, factory: FnwProductTrackingService.ɵfac, providedIn: 'root' });
/** @nocollapse */
FnwProductTrackingService.ctorParameters = () => [
    { type: FnwMessageService }
];
/** @nocollapse */ FnwProductTrackingService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FnwProductTrackingService_Factory() { return new FnwProductTrackingService(ɵɵinject(FnwMessageService)); }, token: FnwProductTrackingService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwProductTrackingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: FnwMessageService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    FnwProductTrackingService.prototype.messageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/product-tracking/product-tracking.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FnwProductTrackingDirective {
    /**
     * @param {?} trackingService
     */
    constructor(trackingService) {
        this.trackingService = trackingService;
        this.productTrackingAction = 'default';
        this.category = 'INTERACTION';
    }
    /**
     * @param {?} productTrackingCategory
     * @return {?}
     */
    set productTrackingCategory(productTrackingCategory) {
        if (['INTERACTION', 'POP_UP'].includes(productTrackingCategory)) {
            this.category = productTrackingCategory;
        }
        else {
            throw new Error('Invalid FnwProductTrackingCategory ' + productTrackingCategory);
        }
    }
    /**
     * @return {?}
     */
    get productTrackingCategory() {
        return this.category;
    }
    /**
     * @param {?} _$event
     * @return {?}
     */
    onEvent(_$event) {
        this.trackingService.trackEvent({
            category: this.productTrackingCategory,
            action: this.productTrackingAction,
            label: this.productTrackingLabel,
            value: this.productTrackingValue,
        });
    }
}
FnwProductTrackingDirective.ɵfac = function FnwProductTrackingDirective_Factory(t) { return new (t || FnwProductTrackingDirective)(ɵngcc0.ɵɵdirectiveInject(FnwProductTrackingService)); };
FnwProductTrackingDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FnwProductTrackingDirective, selectors: [["", "fnwProductTracking", ""]], hostBindings: function FnwProductTrackingDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FnwProductTrackingDirective_click_HostBindingHandler($event) { return ctx.onEvent($event); });
    } }, inputs: { productTrackingAction: "productTrackingAction", productTrackingCategory: "productTrackingCategory", productTrackingLabel: "productTrackingLabel", productTrackingValue: "productTrackingValue" } });
/** @nocollapse */
FnwProductTrackingDirective.ctorParameters = () => [
    { type: FnwProductTrackingService }
];
FnwProductTrackingDirective.propDecorators = {
    productTrackingAction: [{ type: Input }],
    productTrackingLabel: [{ type: Input }],
    productTrackingValue: [{ type: Input }],
    productTrackingCategory: [{ type: Input }],
    onEvent: [{ type: HostListener, args: ['click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwProductTrackingDirective, [{
        type: Directive,
        args: [{
                selector: '[fnwProductTracking]'
            }]
    }], function () { return [{ type: FnwProductTrackingService }]; }, { productTrackingAction: [{
            type: Input
        }], productTrackingCategory: [{
            type: Input
        }], 
    /**
     * @param {?} _$event
     * @return {?}
     */
    onEvent: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], productTrackingLabel: [{
            type: Input
        }], productTrackingValue: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    FnwProductTrackingDirective.prototype.productTrackingAction;
    /** @type {?} */
    FnwProductTrackingDirective.prototype.productTrackingLabel;
    /** @type {?} */
    FnwProductTrackingDirective.prototype.productTrackingValue;
    /**
     * @type {?}
     * @private
     */
    FnwProductTrackingDirective.prototype.category;
    /**
     * @type {?}
     * @private
     */
    FnwProductTrackingDirective.prototype.trackingService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/product-tracking/product-tracking.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FnwProductTrackingModule {
}
FnwProductTrackingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FnwProductTrackingModule });
FnwProductTrackingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FnwProductTrackingModule_Factory(t) { return new (t || FnwProductTrackingModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FnwProductTrackingModule, { declarations: [FnwProductTrackingDirective], exports: [FnwProductTrackingDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwProductTrackingModule, [{
        type: NgModule,
        args: [{
                declarations: [FnwProductTrackingDirective],
                exports: [FnwProductTrackingDirective]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/product-tracking/product-tracking-parameters.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FnwProductTrackingParameters() { }
if (false) {
    /** @type {?} */
    FnwProductTrackingParameters.prototype.category;
    /** @type {?} */
    FnwProductTrackingParameters.prototype.action;
    /** @type {?|undefined} */
    FnwProductTrackingParameters.prototype.label;
    /** @type {?|undefined} */
    FnwProductTrackingParameters.prototype.value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/product-tracking/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/navigation/navigation.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function NavigationState() { }
if (false) {
    /** @type {?} */
    NavigationState.prototype.url;
    /** @type {?} */
    NavigationState.prototype.action;
}
class FnwNavigationService {
    /**
     * @param {?} messageService
     * @param {?} router
     * @param {?} activatedRoute
     * @param {?} config
     */
    constructor(messageService, router, activatedRoute, config) {
        this.messageService = messageService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.config = config;
        this.state = null;
        this.angularJsNavigation = 'IDLE';
    }
    /**
     * @return {?}
     */
    angularJsNavigationStart() {
        this.angularJsNavigation = 'NAVIGATING';
    }
    /**
     * @return {?}
     */
    angularJsNavigationEnd() {
        this.angularJsNavigation = 'IDLE';
    }
    /**
     * @return {?}
     */
    abortAngularJsNavigation() {
        this.angularJsNavigation = 'ABORTED';
    }
    /**
     * @return {?}
     */
    getCurrentWindowLocationHref() {
        return location.href;
    }
    /**
     * @return {?}
     */
    startLocationSync() {
        this.messageService.onMessage().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            switch (data.type) {
                case 'fnw-test-navigate-in-service': {
                    this.updateState({
                        url: data.url,
                        action: 'IN_SERVICE',
                    });
                    /** @type {?} */
                    const serviceUrl = /\/mod\/[^\/]*(.*)/.exec(this.getCurrentWindowLocationHref());
                    if (!this.config.isMonolith &&
                        serviceUrl &&
                        serviceUrl[1] !== data.url) {
                        this.router.navigateByUrl(data.url);
                    }
                    break;
                }
                case 'fnw-test-navigate-to-service': {
                    this.updateState({
                        url: data.url,
                        action: 'RECEIVE_TO_SERVICE',
                    });
                    if (!this.config.isMonolith) {
                        // angularJsNavigation is done by angular / angular-js location sync with anglular / angular-js router
                        this.router.navigateByUrl('/' + FNW_NAVIGATION_ROUTE, {
                            skipLocationChange: true,
                        });
                    }
                    break;
                }
            }
        }));
        this.router.events
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event instanceof NavigationEnd)))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (this.state &&
                this.state.action === 'IN_SERVICE' &&
                this.angularJsNavigation !== 'ABORTED') {
                /** @type {?} */
                const allowMessage = {
                    type: 'fnw-allow-navigation',
                    url: this.state.url,
                    serviceName: this.config.serviceName,
                };
                this.messageService.postMessage(allowMessage);
            }
            if (!this.config.isMonolith) {
                /** @type {?} */
                const section = this.getSectionFromActivatedRoute(this.activatedRoute);
                /** @type {?} */
                const message = {
                    type: 'fnw-location-update',
                    url: event.url,
                    section,
                    serviceName: this.config.serviceName,
                };
                this.messageService.postMessage(message);
            }
            this.state = null;
        }));
        this.router.events
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event instanceof NavigationError)))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            // todo test scenarios
            this.state = null;
        }));
        this.router.events
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event instanceof NavigationCancel)))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (this.state && this.state.action === 'IN_SERVICE') {
                /** @type {?} */
                const message = {
                    type: 'fnw-reject-navigation',
                    url: this.state.url,
                    serviceName: this.config.serviceName,
                };
                this.messageService.postMessage(message);
            }
            this.state = null;
        }));
    }
    /**
     * @private
     * @param {?} state
     * @return {?}
     */
    updateState(state) {
        if (state.url !== '/' + FNW_NAVIGATION_ROUTE) {
            this.state = state;
        }
    }
    /**
     * @param {?} url
     * @return {?}
     */
    navigateToServiceByUrl(url) {
        this.updateState({
            url,
            action: 'TO_SERVICE',
        });
        return this.router.navigateByUrl('/' + FNW_NAVIGATION_ROUTE, {
            skipLocationChange: true,
        });
    }
    /**
     * @param {?} section
     * @return {?}
     */
    setSection(section) {
        /** @type {?} */
        const message = {
            type: 'fnw-section-change',
            serviceName: this.config.serviceName,
            section,
        };
        this.messageService.postMessage(message);
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivate(route, state) {
        if (this.state) {
            switch (this.state.action) {
                case 'TO_SERVICE': {
                    /** @type {?} */
                    const message = {
                        type: 'fnw-navigate-to-service',
                        url: this.state.url,
                        serviceName: this.config.serviceName,
                    };
                    this.messageService.postMessage(message);
                    // this.state = null;
                    // return true;
                    break;
                }
                case 'RECEIVE_TO_SERVICE': {
                    if (this.angularJsNavigation === 'ABORTED') {
                        return false;
                    }
                    else {
                        /** @type {?} */
                        const message = {
                            type: 'fnw-allow-navigation',
                            url: this.state.url,
                            serviceName: this.config.serviceName,
                        };
                        this.messageService.postMessage(message);
                        // this.state = null;
                        // return true;
                        break;
                    }
                }
            }
        }
        this.state = null;
        return false;
    }
    /**
     * @param {?} route
     * @return {?}
     */
    getSectionFromActivatedRoute(route) {
        /** @type {?} */
        let i = 0;
        while (true) {
            if (route.snapshot.data.section) {
                break;
            }
            else {
                if (route.firstChild === null) {
                    break;
                }
                else {
                    route = route.firstChild;
                }
            }
            i++;
            if (i >= 100) {
                // safety for infinite loop
                console.warn('[Companion] route section search took more than 100 iterations');
                break;
            }
        }
        /** @type {?} */
        const section = route.snapshot.data.section;
        return section || null;
    }
}
FnwNavigationService.ɵfac = function FnwNavigationService_Factory(t) { return new (t || FnwNavigationService)(ɵngcc0.ɵɵinject(FnwMessageService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(FnwConfig)); };
FnwNavigationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FnwNavigationService, factory: FnwNavigationService.ɵfac, providedIn: 'root' });
/** @nocollapse */
FnwNavigationService.ctorParameters = () => [
    { type: FnwMessageService },
    { type: Router },
    { type: ActivatedRoute },
    { type: FnwConfig }
];
/** @nocollapse */ FnwNavigationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FnwNavigationService_Factory() { return new FnwNavigationService(ɵɵinject(FnwMessageService), ɵɵinject(Router), ɵɵinject(ActivatedRoute), ɵɵinject(FnwConfig)); }, token: FnwNavigationService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwNavigationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: FnwMessageService }, { type: ɵngcc2.Router }, { type: ɵngcc2.ActivatedRoute }, { type: FnwConfig }]; }, null); })();
if (false) {
    /** @type {?} */
    FnwNavigationService.prototype.state;
    /** @type {?} */
    FnwNavigationService.prototype.angularJsNavigation;
    /**
     * @type {?}
     * @private
     */
    FnwNavigationService.prototype.messageService;
    /**
     * @type {?}
     * @private
     */
    FnwNavigationService.prototype.router;
    /**
     * @type {?}
     * @private
     */
    FnwNavigationService.prototype.activatedRoute;
    /**
     * @type {?}
     * @private
     */
    FnwNavigationService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/navigation/navigation.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NavigationDirective {
    /**
     * @param {?} navigationService
     */
    constructor(navigationService) {
        this.navigationService = navigationService;
    }
    /**
     * @return {?}
     */
    get href() {
        return this.fnwNavigate;
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        $event.stopPropagation();
        $event.preventDefault();
        if (!this.fnwNavigate) {
            console.warn('fnwNavigate only works when an attribute appIFrameNavigate is set');
            return;
        }
        this.navigationService.navigateToServiceByUrl(this.fnwNavigate);
    }
}
NavigationDirective.ɵfac = function NavigationDirective_Factory(t) { return new (t || NavigationDirective)(ɵngcc0.ɵɵdirectiveInject(FnwNavigationService)); };
NavigationDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NavigationDirective, selectors: [["", "fnwNavigate", ""]], hostVars: 1, hostBindings: function NavigationDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NavigationDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("href", ctx.href, ɵngcc0.ɵɵsanitizeUrlOrResourceUrl);
    } }, inputs: { fnwNavigate: "fnwNavigate" } });
/** @nocollapse */
NavigationDirective.ctorParameters = () => [
    { type: FnwNavigationService }
];
NavigationDirective.propDecorators = {
    fnwNavigate: [{ type: Input }],
    href: [{ type: HostBinding }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavigationDirective, [{
        type: Directive,
        args: [{
                selector: '[fnwNavigate]'
            }]
    }], function () { return [{ type: FnwNavigationService }]; }, { href: [{
            type: HostBinding
        }], 
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], fnwNavigate: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    NavigationDirective.prototype.fnwNavigate;
    /** @type {?} */
    NavigationDirective.prototype.navigationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/navigation/navigation.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FnwNavigationModule {
}
FnwNavigationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FnwNavigationModule });
FnwNavigationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FnwNavigationModule_Factory(t) { return new (t || FnwNavigationModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FnwNavigationModule, { declarations: [NavigationDirective], exports: [NavigationDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwNavigationModule, [{
        type: NgModule,
        args: [{
                declarations: [NavigationDirective],
                exports: [NavigationDirective]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/navigation/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/webapp-loader-companion-base.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WebappLoaderCompanionBaseModule {
    /**
     * @param {?} navigationService
     * @param {?} messageService
     * @param {?} config
     * @param {?} ngZone
     */
    constructor(navigationService, messageService, config, ngZone) {
        this.navigationService = navigationService;
        this.messageService = messageService;
        this.config = config;
        this.ngZone = ngZone;
        this.navigationService.startLocationSync();
        this.ngZone.runOutsideAngular((/**
         * @return {?}
         */
        () => {
            window.addEventListener('scroll', (/**
             * @param {?} e
             * @return {?}
             */
            e => {
                /** @type {?} */
                const scrollY = window.pageYOffset;
                /** @type {?} */
                const scrollMaxY = document.body.scrollHeight - window.innerHeight;
                /** @type {?} */
                const message = {
                    type: 'fnw-scroll-change',
                    scrollY,
                    scrollMaxY,
                    serviceName: this.config.serviceName,
                };
                this.messageService.postMessage(message);
            }));
            window.addEventListener('resize', (/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const scrollY = window.pageYOffset;
                /** @type {?} */
                const scrollMaxY = document.body.scrollHeight - window.innerHeight;
                /** @type {?} */
                const message = {
                    type: 'fnw-height-change',
                    scrollY,
                    scrollMaxY,
                    serviceName: this.config.serviceName,
                };
                this.messageService.postMessage(message);
            }));
            /** @type {?} */
            const resizeObserver = new ResizeObserver((/**
             * @param {?} entries
             * @param {?} observer
             * @return {?}
             */
            (entries, observer) => {
                /** @type {?} */
                const scrollY = window.pageYOffset;
                /** @type {?} */
                const scrollMaxY = document.body.scrollHeight - window.innerHeight;
                /** @type {?} */
                const message = {
                    type: 'fnw-height-change',
                    scrollY,
                    scrollMaxY,
                    serviceName: this.config.serviceName,
                };
                this.messageService.postMessage(message);
            }));
            resizeObserver.observe(document.body);
        }));
    }
}
WebappLoaderCompanionBaseModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WebappLoaderCompanionBaseModule });
WebappLoaderCompanionBaseModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function WebappLoaderCompanionBaseModule_Factory(t) { return new (t || WebappLoaderCompanionBaseModule)(ɵngcc0.ɵɵinject(FnwNavigationService), ɵngcc0.ɵɵinject(FnwMessageService), ɵngcc0.ɵɵinject(FnwConfig), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); }, imports: [[FnwEmptyModule, HttpClientModule], FnwEmptyModule, HttpClientModule] });
/** @nocollapse */
WebappLoaderCompanionBaseModule.ctorParameters = () => [
    { type: FnwNavigationService },
    { type: FnwMessageService },
    { type: FnwConfig },
    { type: NgZone }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WebappLoaderCompanionBaseModule, { imports: function () { return [FnwEmptyModule, HttpClientModule]; }, exports: function () { return [FnwEmptyModule, HttpClientModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WebappLoaderCompanionBaseModule, [{
        type: NgModule,
        args: [{
                imports: [FnwEmptyModule, HttpClientModule],
                exports: [FnwEmptyModule, HttpClientModule]
            }]
    }], function () { return [{ type: FnwNavigationService }, { type: FnwMessageService }, { type: FnwConfig }, { type: ɵngcc0.NgZone }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    WebappLoaderCompanionBaseModule.prototype.navigationService;
    /**
     * @type {?}
     * @private
     */
    WebappLoaderCompanionBaseModule.prototype.messageService;
    /**
     * @type {?}
     * @private
     */
    WebappLoaderCompanionBaseModule.prototype.config;
    /**
     * @type {?}
     * @private
     */
    WebappLoaderCompanionBaseModule.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/webapp-loader-companion.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WebappLoaderCompanionModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: WebappLoaderCompanionModule,
            providers: [
                {
                    provide: FnwConfig,
                    useValue: config,
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: loadCredentials,
                    deps: [FnwCredentialsService],
                    multi: true,
                },
            ],
        };
    }
}
WebappLoaderCompanionModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WebappLoaderCompanionModule });
WebappLoaderCompanionModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function WebappLoaderCompanionModule_Factory(t) { return new (t || WebappLoaderCompanionModule)(); }, imports: [[WebappLoaderCompanionBaseModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WebappLoaderCompanionModule, { imports: [WebappLoaderCompanionBaseModule] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WebappLoaderCompanionModule, [{
        type: NgModule,
        args: [{
                imports: [WebappLoaderCompanionBaseModule]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/webapp-loader-companion.routes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FNW_ROUTES = [
    {
        path: FNW_NAVIGATION_ROUTE,
        component: FnwEmptyComponent,
        canActivate: [FnwNavigationService],
        runGuardsAndResolvers: 'always',
    },
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/http-auth-interceptor.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HttpXsrfTokenInterceptorService {
    /**
     * @param {?} tokenExtractor
     */
    constructor(tokenExtractor) {
        this.tokenExtractor = tokenExtractor;
        this.xsrfTokenHeaderName = 'X-XSRF-TOKEN';
    }
    /**
     * @param {?} httpRequest
     * @param {?} next
     * @return {?}
     */
    intercept(httpRequest, next) {
        /** @type {?} */
        const token = this.tokenExtractor.getToken();
        if (token !== null && !httpRequest.headers.has(this.xsrfTokenHeaderName)) {
            httpRequest = httpRequest.clone({
                headers: httpRequest.headers.set(this.xsrfTokenHeaderName, token),
            });
        }
        return next.handle(httpRequest);
    }
}
HttpXsrfTokenInterceptorService.ɵfac = function HttpXsrfTokenInterceptorService_Factory(t) { return new (t || HttpXsrfTokenInterceptorService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpXsrfTokenExtractor)); };
HttpXsrfTokenInterceptorService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HttpXsrfTokenInterceptorService, factory: HttpXsrfTokenInterceptorService.ɵfac });
/** @nocollapse */
HttpXsrfTokenInterceptorService.ctorParameters = () => [
    { type: HttpXsrfTokenExtractor }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HttpXsrfTokenInterceptorService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpXsrfTokenExtractor }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    HttpXsrfTokenInterceptorService.prototype.xsrfTokenHeaderName;
    /**
     * @type {?}
     * @private
     */
    HttpXsrfTokenInterceptorService.prototype.tokenExtractor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: farmnet-webapp-loader-companion.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { CREDENTIALS_ENDPOINT, FNW_NAVIGATION_ROUTE, FNW_ROUTES, FnwConfig, FnwCredentialsService, FnwEmptyComponent, FnwEmptyModule, FnwLocationService, FnwMessageService, FnwNavigationModule, FnwNavigationService, FnwProductTrackingDirective, FnwProductTrackingModule, FnwProductTrackingService, HttpXsrfTokenInterceptorService, LOCATION, NavigationDirective, SubscriptionState, WebappLoaderCompanionBaseModule, WebappLoaderCompanionModule, loadCredentials, mapToLocale };

//# sourceMappingURL=farmnet-webapp-loader-companion.js.map